import Client from "./_client";

export const createShortlistTask = async (payload , id) => {

   let result;

   if(id){
    result = await new Client({
      path : `/shortlistTask/${id}`,
      payload : payload
    }).put();
   }else{
    result = await new Client({
      path: `/shortlistTask`,
      payload: payload
    }).post();
   }

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to create shortlisting task. Please try again."
        );
    }

    return result.data;
}

export const getShortlistingTasks = async (filters = {}) => {
  let url = "/shortlistTask?include=batch";

  const filterKeys = Object.keys(filters).filter((key) => filters[key]);
  if (filterKeys.length) {
    filterKeys.forEach((key, index) => {
      url += `&${key}=${filters[key]}`;
    });
  }

  const result = await new Client({ path: url }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get shortlisting tasks. Please try again."
    );
  }
  return result?.data;
};


export const getShortlistTaskById = async (id) => {
  let url = `/shortlistTask/${id}?user=true&batch=true`;
  
    const result = await new Client({
      path: url,
    }).get();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to get shortlist task. Please try again."
      );
    }
    return result?.data;
  }

export const deleteShortlistTaskById = async (id) => {
    let url = `/shortlistTask/${id}`;
  
  
    const result = await new Client({
      path: url,
    }).delete();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to delete shortlist task. Please try again."
      );
    }
    return result?.data;
  }

export const getShortlistAttemptRate = async (id) => {
    let url = `/analytics/shortlistTask/${id}/attempt-rate`;
  
  
    const result = await new Client({
      path: url,
    }).get();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to get attempt rate. Please try again."
      );
    }
    return result?.data;
  }

export const getShortlistAvgDistribution = async (id) => {
    let url = `/analytics/shortlistTask/${id}/avg-distribution `;
  
  
    const result = await new Client({
      path: url,
    }).get();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to get average distribution. Please try again."
      );
    }
    return result?.data;
  }

  export const getResumeAnalysisHistory = async (filters = {}) => {
    const params = new URLSearchParams({ include: "user,resume,shortlistTask" });
  
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined) params.append(key, value);
    });
  
    const url = `/resumeInsight?${params.toString()}`;
  
    const result = await new Client({ path: url }).get();
  
    if (!(result.ok || result.code === 200)) {
      throw new Error(
        result.message || "Uh Oh! Unable to fetch history. Please try again."
      );
    }
  
    if (result.name === "DuplicateSession") {
      return result;
    } else {
      return result.data;
    }
  };